module.exports = __webpack_public_path__ + "media/images/plans/photo_location/photo_location-4-1fc01b2174c61255f03db598883e23a2.png";